<template>
  <div class="chart-content">
    <div class="chart" ref="myChart">
    </div>
  </div>
</template>

<script>
import elementResizeDetectorMaker from "element-resize-detector";
// import {
//   GetDeptApplyDatas
// } from '@/api'
import BaseReportMixin from '@/mixin/baseReport-mixin.js'
import { EleResize } from '@/utils/EleResize.js'
export default ({
  mixins: [BaseReportMixin],
  data () {
    return {
      myChart: null,
      option: {},
      data: [],
      nameData: [],
      setInterval: null
    };
  },
  props: {
    name: {
      type: String,
      default () {
        return ''
      }
    },
    getDataAction: {
      type: Function,
      default () {
        return null
      }
    },
    isShowCloseBtn: {
      type: Boolean,
      default () {
        return true
      }
    },
    xAxisName: {
      type: String,
      default () {
        return ''
      }
    },
    seriesName: {
      type: String,
      default () {
        return ''
      }
    },
  },
  //监听beforinfo值的变化
  watch: {
    data: {
      handler (newVal, oldVal) {
        this.initOption()
        this.option.series[0].data = newVal
        if (!this.myChart) {
          this.myChart = this.$echarts.init(this.$refs['myChart'])
        }
        this.myChart.setOption(this.option);
      },
      deep: true
    },
  },
  methods: {
    // 获取列表
    getData () {
      this.getDataAction({})
        .then(res => {
          this.data = res.returnData.map(e => e.value);
          this.nameData = res.returnData.map(e => e.name);
          // console.log(res.returnData, "returnData")
          // console.log(res.returnData.values, "values")
          // console.log(res.returnData.names, "names")
          // console.log(res.returnData.lineValues, "lineValues")
        })
    },
    initOption () {
      let that = this;
      this.option = {
        title: {
          text: this.name,
          textStyle: {
            color: "#FFF" // 标题颜色
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#283b56'
            }
          }
        },
        toolbox: this.getToolBox(this),
        // dataZoom: {
        //   show: false,
        //   start: 0,
        //   end: 100
        // },
        yAxis: [
          {
            type: 'category',
            boundaryGap: true,
            data: this.nameData,
            axisLine: {
              show: true,
              lineStyle: {
                color: '#fff'
              }
            },
            axisLabel: {
              show: false,
            },
            // axisTick: {
            //   show: true // 不显示坐标轴刻度线
            // },
          }
        ],
        xAxis: [
          {
            type: 'value',
            scale: true,
            name: this.xAxisName,//'金额(万元)',
            // max: 700,
            // interval: 100,
            min: 0,
            // boundaryGap: [0.2, 0.2],
            nameTextStyle: {
              color: "#fff", // 蓝色
              fontSize: 12,
            },
            nameLocation: 'middle',
            nameGap: 25,
            axisLine: {
              // show: false,//坐标轴线
              show: true,
              lineStyle: {
                color: '#fff'
              }
            },
            splitLine: {
              show: false
            }
          }
        ],
        series: [
          {
            name: this.seriesName,//'汇总金额',
            type: 'bar',
            barWidth: 20,
            data: this.data,
            label: {
              show: true,
              color: '#fff',
              align: 'left',
              offset: [20, 0],
              formatter: function (e) {
                return e.name
              },
              position: 'left'
              // verticalAlign: "top",
            },
            itemStyle: {
              normal: {
                color: '#06B5D7',
                //  new this.$echarts.graphic.LinearGradient(
                //   0, 0, 0, 1,
                //   [
                //     { offset: 0, color: '#71C8B1' },                  //点击柱图高亮渐变色
                //     { offset: 0.7, color: '#44C0C1' },                //柱图高亮渐变色
                //     { offset: 1, color: '#06B5D7' }                //柱图高亮渐变色
                //   ]
                // )
              }
            }
          }
        ],
        grid: {
          left: '5%',
          show: false
        }
      }
    },


    init () {
      // this.initOption()
      // this.option.width = this.width
      // this.option.height = this.height
      this.myChart = this.$echarts.init(this.$refs['myChart'])
      // this.myChart.setOption(this.option);

      // // 随窗口的大小变化自适应
      // window.addEventListener("resize", function () {
      //   myChart.resize();
      // });
      //  随外层div的大小变化自适应
      const _this = this
      let erd = elementResizeDetectorMaker();
      erd.listenTo(this.$refs.myChart, (e) => {

        _this.$nextTick(() => {
          _this.myChart.resize();
          var parentNodeId = e.parentNode.parentElement.id
          var domId = document.getElementById(parentNodeId);
          if (domId) {
            _this.$emit('SizeChange', domId.clientWidth, domId.clientHeight, parentNodeId)
          }
        })
      })

      //  const _this = this
      // let erd = elementResizeDetectorMaker();
      // let myChart = this.$refs.myChart
      // erd.listenTo(myChart, (e) => {
      //   _this.$nextTick(() => {
      //     _this.myChart.resize();
      //     let parentNode = myChart.parentNode
      //     // console.log(parentNode, 'parentNode')
      //     _this.$emit('SizeChange', myChart.clientWidth, myChart.clientHeight, parentNode.parentElement.id)
      //   })
      // })

      //  EleResize.on(this.$refs['chart'], (e) => {
      //   // console.log(e.target.innerHeight, 'e')
      //   // console.log(this.$refs['chart'].parentNode, 'this.$refs')
      //   this.$emit('SizeChange', e.target.innerWidth, e.target.innerHeight, this.$refs['chart'].parentNode.id)
      // })
    },

  },//自定义指令


  mounted () {
    this.init()
    this.getData();
    let that = this

    this.setInterval = setInterval(function () {
      that.getData();
    }, 5 * 60 * 1000);//每隔1秒执行每次刷新数据的函数
    // (function () {
    //   that.init();//这个是预加载 把报表的框架加载出来
    // })
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
    // this.getData();
  },
  beforeDestroy () {
    clearInterval(this.setInterval)
  },
})
</script>
<style scoped lang="scss">
.chart-content {
  width: 100%;
  height: 400px;
  display: flex;
  .chart {
    width: 100%;
    height: 100%;
    position: absolute; // 拖动时报表随div缩放
  }
}
</style>
